// common reducer for handling common state changes
export const commonReducer = (state, action) => {
    switch (action.type) {
        case 'CLEAR_USER': {
            return {}
        }
         case 'SET_ALL_FIELDS': {
            return { ...state, fields: action.payload };
        }
        default:
            return state;
    }
}

// Initial state for common
export const initialCommonState = {
     fields: {},
}; 